(function($) {
$.widget("ca.caCreateNewClient", {
    options : {
        firstName : '',
        lastName : '',
        isCorporate : 0,
        parentId: 0
    },

    open : function() {
        var self = this;

        var dialog = $('<div class="ca-create-user-form"></div>').appendTo('body');

        $.caPost('/user/get-user-form', {
            first_name: self.options.firstName,
            last_name: self.options.lastName,
            is_corporate: self.options.isCorporate,
            parentId: self.options.parentId
        }, function(response) {
            if (response.status == 1) {
                dialog.html(response.content);
                var form = dialog.find('form');
                dialog.caDialog({
                    autoOpen : true,
                    title : self.options.isCorporate ? '<b>Create</b> Corporate Account' : '<b>Create</b> Client',
                    staticForm: false,
                    caProUI: true
                });
                self._bindDialog(dialog, form);
            } else {
                $.caAlert(response.message);
            }
        });
    },

    close : function() {
        $('.ca-create-user-form').caDialog('close');
    },

    setName : function(input) {
        var names = input.replace(/^[ ]+/, '').replace(/[ ]+$/, '').split(/[ ]+/);
        this.options.firstName = names[0];
        if (names.length >= 2) {
            delete names[0];
            this.options.lastName = names.join(' ');
        }
    },

    _bindDialog : function(dialog, form) {
        var self = this;

        dialog.find('#cancel_create_user_button').on('click', function() {
            dialog.caDialog('close');
            return false;
        });

        dialog.find('#create_user_button').on('click', function() {
            $('body').caLoadingSplash('show');
            $(form).ajaxSubmit({
                dataType : 'json',
                success : function(response) {
                    if (response.success == true) {

                        self.close();
                        $('body').caLoadingSplash('hide');

                        if (self.element.data('ca-caAutocomplete') != undefined) {
                            self.element.caAutocomplete('setItem', response.user);
                        }

                        if (self.element.data('ca-caUserPicker') != undefined) {
                            self.element.caUserPicker('setItem', response.user);
                        }

                        var newUserLink = '/user/edit?id=' + response.user.id;
                        window.open(newUserLink, '_blank');
                    } else {
                        dialog.html(response.formHTML);
                        form = dialog.find('form');
                        self._bindDialog(dialog, form);
                        $('body').caLoadingSplash('hide');
                    }
                }
            });
            return false;
        });

        dialog.find('#create_new_client_phone_cell').on('keyup', function(){
            self.validateCell();
        });
        self.validateCell();
    },

    validateCell : function() {
        var cellFieldValue = $('#create_new_client_phone_cell').val();
        var cellFieldPopulated = !!cellFieldValue && $('#create_new_client_phone_cell').val() !== '';
        var smsOptions = $('#create_new_client_sms_optin').closest('div.form-group');
        if(cellFieldPopulated){
            smsOptions.show();
        } else {
            smsOptions.hide();
            $('#create_new_client_sms_optin input[type="radio"]').each(function(){
                $(this).prop('checked',false);
            });
        }
    }
});
})(jQuery);
